import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Dispatch,
  RootState,
  useRematchDispatch,
  useRematchState
} from '@/store';
import { openOrDownloadUrl } from '@/utils/open-or-download-url';
import { parseQuery, getTargetUrl } from '@/utils/url';
import { className, isInApp, isInYoda, toLogin } from '@/utils/helpers';
import { HOME_PAGE_URL } from '@/configs/constants';
import yoda from '@ks/yoda-js-sdk';
import useDeviceInfo from '@/utils/useDeviceInfo';
import HelpFeedbackEntrance from '@/components/HelpFeedbackEntrance';
import { IItemTab } from '@/schemas/common';
import NavBottom from '@/components/NavBottom';
import IconFont from '@/components/Iconfont';
import loadable from '@loadable/component';
import Menu from './containers/Menu';
import Live from './containers/Live';
import NavBarScroll from './components/NavBarScrollFit';
import FollowBar from './components/FollowBar';
import RecommendList from './containers/RecommendList';
import RecommendDoctors from './containers/RecommendDoctors';
// import RecommendConsultDoctor from './containers/RecommendConsultDoctor';
import styles from './index.module.scss';

const NavBanner = loadable(() => import('./containers/NavBanner'));
const ConsultingOrderCard = loadable(() =>
  import('./components/ConsultingOrderCard')
);

const bottomNavData: IItemTab[] = [
  {
    title: '首页',
    iconClassName: 'common_base_home_24'
  },
  {
    title: '我的订单',
    iconClassName: 'common_base_order_24',
    link: '/order/records'
  }
];

const mapState = (state: RootState) => ({
  isDoctor: state.user.doctor,
  isLogin: state.user.isLogin,
  tabs: state.home.tabs,
  loading:
    state.loading.effects.home.getMenu || state.loading.effects.home.getBanner,
  tabBarTop: state.home.tabBarTop
});

const mapDispatch = (dispatch: Dispatch) => ({
  getTabs: dispatch.home.getTabs,
  getUserInfo: dispatch.user.getUserInfo,
  updateHomeSate: dispatch.home.updateState
});

const Home = () => {
  const { isLogin, isDoctor } = useRematchState(mapState);
  const { getUserInfo } = useRematchDispatch(mapDispatch);
  const { from, pid, mode } = parseQuery() as any;
  const [isFollowBarShow, setIsFollowBarShow] = useState(false);
  const history = useHistory();
  const homeRef = useRef<any>(null);
  const navBgDomRef = useRef<any>(null);

  const [showRecommendList, setShowRecommendList] = useState(false);

  useEffect(() => {
    if (!isLogin && isInApp) {
      getUserInfo().catch((e) => {
        //
      });
    }

    if (isLogin) {
      // afterLogin();
    }

    const rootHome = homeRef.current;

    rootHome.addEventListener('click', checkIsLogin, true);

    return () => {
      rootHome.removeEventListener('click', checkIsLogin, true);
    };
  }, [isLogin]);

  useEffect(() => {
    // 如果是医生角色，自动跳转到医生工作台页面
    if (isDoctor && from !== 'workstation' && mode !== 'user') {
      history.replace(getTargetUrl('/doctor-workstation'));
    }
  }, [isDoctor]);

  useEffect(() => {
    // 每日科普打开视频
    if (Number(pid)) {
      const kUrl = `kwai://work/${pid}`;
      openOrDownloadUrl(kUrl);
    }
  }, []);

  const { statusBarHeight } = useDeviceInfo();
  useEffect(() => {
    if (statusBarHeight && navBgDomRef.current) {
      const str = window
        .getComputedStyle(navBgDomRef.current, null)
        .getPropertyValue('height');
      if (str) {
        const num = Number(str.slice(0, -2));
        navBgDomRef.current.style.height = `${num - statusBarHeight}px`;
      }
    }
  }, [statusBarHeight]);

  const agreementComponent = () => {
    return (
      <div
        role="presentation"
        className={styles['home-share']}
        onClick={() => {
          if (yoda.isInYoda) {
            openOrDownloadUrl(
              `${window.location.origin}/agreements?layoutType=4&enableWK=1&hyId=healthy-channel`
            );
          } else {
            history.push('/agreements');
          }
        }}
      >
        <div className={styles['i-wrapper']}>
          <IconFont icon="common_base_infor_24" />
        </div>
        <h3>协议</h3>
      </div>
    );
  };

  const checkIsLogin = (event) => {
    if (isInYoda) {
      if (!isLogin) {
        event.stopPropagation();
        toLogin(() => {
          window.location.reload();
        });
      }
    } else if (!isLogin) {
      event.stopPropagation();
      openOrDownloadUrl(HOME_PAGE_URL);
    }
  };

  return (
    <div
      className={
        isInYoda
          ? className(styles.home, styles['home-has-nav-bottom'])
          : styles.home
      }
    >
      <div className={styles['nav-bg']} ref={navBgDomRef} />
      <NavBarScroll
        showNavWorkStation
        shareComponent={agreementComponent()}
        title=""
      />
      <div ref={homeRef} className={styles['home-main-wrap']}>
        <Menu />
        <NavBanner />
        <ConsultingOrderCard />
        {/* <RecommendConsultDoctor /> */}
        <Live />
        <RecommendDoctors onLoad={() => setShowRecommendList(true)} />
        {showRecommendList ? <RecommendList /> : null}
        <FollowBar isShow={isFollowBarShow} setIsShow={setIsFollowBarShow} />
        <HelpFeedbackEntrance isFollowBarShow={isFollowBarShow} />
        <NavBottom iconfont data={bottomNavData} hasLogin={isLogin} />
      </div>
    </div>
  );
};

export default Home;
